module.exports = __webpack_public_path__ + "img/letter.4a4f58d2.png";